module.exports = __webpack_public_path__ + "static/media/p_8_2.06f9d699.png";